import { useQuery } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

import { type SchoolYearAndBreakToggle } from '../types'

type Params = {
  status?: SchoolYearAndBreakToggle
}

const useSchoolYearsCount = (params: Params) =>
  useQuery({
    queryKey: ['panelPeriodsYearsListCount', params],
    staleTime: 60 * 100,
    queryFn: async () => {
      const response = await httpService.panel.panelPeriodsYearsList({
        page_size: 1,
        status: params.status === 'past' ? ['archived'] : ['active', 'future'],
        fetchKeys: {
          id: true
        }
      })

      return response.count
    }
  })

export default useSchoolYearsCount
